let apiUrl = process.env.VUE_APP_API_URL;


class ParamEgressApi {

    getList() {
        var url = apiUrl + 'paramEgresses';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }


    getByBuildingCode(ruleId) {
        var url = apiUrl + 'paramEgresses/ByBuildingRule/' + ruleId;
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getParamEgressesByBuildingCode(id) {
      var url = apiUrl + `paramEgresses?buildingCodeId=${id}&limit=10&page=1`
      return api.call('get', url)
          .then(({ data }) => {
              return data
          });
    }


    get(id) {
        var url = apiUrl + 'paramEgresses/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });
    }

    create(data) {
        var url = apiUrl + 'paramEgresses';
        return api.call('post', url, data)
            .then(({ data }) => {
                return data
            });

    }
    update(data) {
        var url = apiUrl + 'paramEgresses/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }
    delete(id) {
        var url = apiUrl + 'paramEgresses/';
        return api.call('delete', url + id)
            .then(({ data }) => {
                return data
            });
    }

}

export default ParamEgressApi;
